import React from "react";
import { NavLink } from "react-router-dom";
import Container from "../../../../modules/commons/Container";
import FlexView from "react-flexview";

const menuItems = [
  {
    label: "Laporan Harian Unit By Cabang",
    link: "/dashboard/level-kabeng-keatas/laporan-harian-unit-by-cabang",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_laporan_harian_unit_by_cabang",
  },
  {
    label: "Laporan Harian Unit By Mekanik",
    link: "/dashboard/level-kabeng-keatas/laporan-harian-unit-by-mekanik",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_laporan_harian_unit_by_mekanik",
  },
  {
    label: "Laporan Harian Part By Cabang",
    link: "/dashboard/level-kabeng-keatas/laporan-harian-part-by-cabang",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_laporan_harian_part_by_cabang",
  },
  {
    label: "Laporan Harian Part By Mekanik",
    link: "/dashboard/level-kabeng-keatas/laporan-harian-part-by-mekanik",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_laporan_harian_part_by_mekanik",
  },
  {
    label: "Laporan Tambahan",
    link: "/dashboard/level-kabeng-keatas/laporan-tambahan",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_laporan_tambahan",
  }
];

const DashboardLevelKabengKeatas = () => {
  return (
    <React.Fragment>
      <Container>
        <FlexView style={{ gap: "20px" }}>
          {menuItems.map((item) => (
            <NavLink key={item.id} id={item.id} to={item.link}>
              <FlexView
                column
                vAlignContent="center"
                hAlignContent="center"
                className="background-red txt-site txt-white"
                style={{
                  width: 235,
                  height: 235,
                  border: "2px solid #000",
                  borderRadius: 5,
                  gap: "10px",
                }}
              >
                <i className={`${item.icon} fa-lg`}></i>
                <div className="text-center" style={{ textAlign: 'center', maxWidth:"200px"}}>{item.label}</div>
              </FlexView>
            </NavLink>
          ))}
        </FlexView>
      </Container>
    </React.Fragment>
  );
};

export default DashboardLevelKabengKeatas;
